import * as api from "services/api";
import { getErrors } from "helpers/error";

export const UPDATE_CONTRACT_TEMPLATE =
	"[UPDATE CONTRACT] UPDATE_CONTRACT_TEMPLATE";
export const UPDATE_CONTRACT_TEMPLATE_ERROR =
	"[UPDATE CONTRACT] UPDATE_CONTRACT_TEMPLATE_ERROR";
export const UPDATE_CONTRACT_TEMPLATE_SUCCESS =
	"[UPDATE CONTRACT] UPDATE_CONTRACT_TEMPLATE_SUCCESS";

export const SET_VALUE = "[UPDATE CONTRACT] SET_VALUE";
export const CLEAR_VALUES = "[UPDATE CONTRACT] CLEAR_VALUES";

export function setValue(payload) {
	return dispatch => {
		dispatch({ type: SET_VALUE, payload });
	};
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function updateTemplateContract(id, model, callback) {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_CONTRACT_TEMPLATE
		});

		try {
			const { login } = getState();

			let response = await api.sendPut(
				`/templates/update-contract/${id} `,
				model,
				{
					Authorization: "Bearer " + login.token
				}
			);
			let result = await response.json();

			if (response.ok) {
				dispatch({
					type: UPDATE_CONTRACT_TEMPLATE_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: UPDATE_CONTRACT_TEMPLATE_ERROR,
					payload: errors
				});

				callback && callback(errors);
			}
		} catch (error) {
			console.log(error);

			return dispatch({
				type: UPDATE_CONTRACT_TEMPLATE_ERROR,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
